import React, { ReactElement, useContext } from 'react'
import { DEFAULT_VALUE, jsonKeyMapping } from '../../../Config/Constants'

import InputContext from '../../../Contexts/Input.Context'
import useLoadMoreFields from '../../../Hooks/LoadMoreFields'
import { TemplateObject } from '../../../Models/TemplateObject'
import FormBuilder from '../../FormBuilder/FormBuilder'
import ToolTipWithLabelComponent from '../ToolTipWithLabelComponent'
import { removeSemicolons } from '../../../Util/TextUtils'

type Props = {
    children: React.ReactNode,
    formElement: TemplateObject,
    label: string,
    labelsub: string,
    subtext: string,
}

const InputWrapper = ({ children, formElement, label, labelsub, subtext}: Props): ReactElement => {
    const { conditionalInput } = useContext(InputContext)
    /* Load More Fields Based Upon Previous Selected Values */
    useLoadMoreFields({ formElement })
    
    // Remove semicolons/colons from labels
    const cleanLabel = removeSemicolons(label);
    const cleanLabelSub = removeSemicolons(labelsub);
    
    return (
        <div className={`${formElement[jsonKeyMapping.FORM_ADD_MORE] ? '' : 'form-group'} ${formElement.class ? formElement.class : ''}`} style={formElement?.id === jsonKeyMapping.STATE_SPECIFIC_STATE ? { marginTop: 10}:{ marginTop: 10,float:'left',paddingRight:'10px' }}>
            {formElement[jsonKeyMapping.FORM_SUB_TOOLTIP]
                ? (
                    <ToolTipWithLabelComponent
                        tooltipClass="tooltip-bulb"
                        labelClass={'form-label text-right'}
                        formElement={formElement}
                    />
                )
                : (
                  <>
                    {labelsub !== '' && subtext !== '' ? <><div><label className="form-label text-right d-inline">{cleanLabelSub}</label><small className="form-text text-muted subtext  d-md-block">{subtext}</small></div> </>:""}
                  <label className="form-label text-right d-inline">{cleanLabel}</label>
                  {labelsub === '' && subtext !== '' ? <><div><small className="form-text text-muted subtext  d-md-block">{subtext}</small></div></>:""}
                  </>
                )
            }
            {formElement[jsonKeyMapping.FORM_SUB_LABEL] && <div>{formElement[jsonKeyMapping.FORM_SUB_LABEL]}</div>}
            <div className='mt-2'></div>
            <div>
                {children}
            </div>
            {conditionalInput && (
                <FormBuilder
                    formGroup={conditionalInput.formElement}
                    hasParent={{
                        [jsonKeyMapping.FORM_ID]: formElement[jsonKeyMapping.FORM_ID],
                        [jsonKeyMapping.FORM_LABEL]: conditionalInput.parentLabel,
                        showElement: conditionalInput.value || DEFAULT_VALUE
                    }} />
            )}
        </div>
    )
}

export default InputWrapper
